const PRECEDENT_ROUTE = "precedents";

function currentRelativeUrl() {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function buildPrecedentDetailUrl({
  caseId,
  query = "",
  source = "domestic",
  returnTo = currentRelativeUrl(),
}) {
  const p = new URLSearchParams();
  p.set("audit", PRECEDENT_ROUTE);
  p.set("case", String(caseId || ""));
  if (query) p.set("origin_q", String(query));
  if (source === "foreign") p.set("origin_source", "foreign");
  if (returnTo) p.set("return_to", String(returnTo));
  return `/?${p.toString()}`;
}

export function buildPrecedentSearchUrl({
  query,
  source = "domestic",
  returnTo = currentRelativeUrl(),
  splitView = false,
}) {
  const p = new URLSearchParams();
  p.set("audit", PRECEDENT_ROUTE);
  if (query) p.set("origin_q", String(query));
  if (source === "foreign") p.set("origin_source", "foreign");
  if (returnTo) p.set("return_to", String(returnTo));
  if (splitView) p.set("view", "split");
  return `/?${p.toString()}`;
}

export function readPrecedentNavigation(search = "") {
  const p = new URLSearchParams(search);
  return {
    caseId: p.get("case") || null,
    originQuery: p.get("origin_q") || "",
    originSource: p.get("origin_source") === "foreign" ? "foreign" : "domestic",
    returnTo: p.get("return_to") || null,
    splitView: p.get("view") === "split",
  };
}

export function normalizeReturnTo(raw, origin) {
  if (!raw) return null;
  const base = origin || (typeof window !== "undefined" ? window.location.origin : "https://loginhs.co.kr");
  try {
    const target = new URL(raw, base);
    if (target.origin !== new URL(base).origin) return null;
    if (new URLSearchParams(target.search).get("audit") === PRECEDENT_ROUTE) return null;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return null;
  }
}

export function navigateToPrecedentDetail(caseId, { query = "", source = "domestic" } = {}) {
  if (!caseId || typeof window === "undefined") return;
  const next = buildPrecedentDetailUrl({ caseId, query, source });
  window.history.pushState({ precedentReturnTo: currentRelativeUrl() }, "", next);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function navigateToPrecedentSearch(
  query,
  {
    source = "domestic",
    returnTo = currentRelativeUrl(),
    splitView = false,
  } = {},
) {
  if (!query || typeof window === "undefined") return;
  const next = buildPrecedentSearchUrl({ query, source, returnTo, splitView });
  window.history.pushState({ precedentReturnTo: returnTo }, "", next);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function navigateToReturnTarget(raw) {
  if (typeof window === "undefined") return false;
  const target = normalizeReturnTo(raw, window.location.origin);
  if (!target) return false;
  window.history.pushState({}, "", target);
  window.dispatchEvent(new PopStateEvent("popstate"));
  return true;
}
